<template>
    <div class="popup" v-show="show">
        <div class="create bg_white">
            <Icon class="closer cursor_pointer" type="md-close" @click="show=false" size="26"/>
            <div class="title f18 bold500 txt_black87 tc">新建维护人员</div>
            <div class="content">
                <div class="item txt_black54 f14 bold500">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        电话：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="text" placeholder="请输入电话号码" v-model="phone"/>
                    </div>
                </div>
                <div class="item txt_black54 f14 bold500">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        点位：
                    </div>
                    <selection class="select fl w100" :options="points" v-model="point"></selection>
                </div>
            </div>
            <div class="submit tc">
                <button class="bg_E91E63 f18 bold400 txt_white tc cursor_pointer" @click="submitEvent">提交</button>
            </div>
        </div>

<!--        <select-user ref="selectUser" @confirmCallback="userCallback"></select-user>-->
    </div>
</template>

<script>
    // import SelectUser from '@/components/selectUser'
    export default {
        name: "create",
        components:{

        },
        data() {
            return {
                show: false,
                phone: '',
                points: [],
                pointIds: [],
                point: ''
            }
        },
        created() {
            this.getPoints();
        },
        methods: {
            init() {
                this.show = true;
            },
            getPoints() {
                this.$api.get('/manage/point').then((res) => {
                    this.points = res.data.map(item => item.name);
                    this.pointIds = res.data.map(item => item.id);
                }).catch((error) => {
                    this.$alert.error({content: '获取点位列表失败'});
                });
            },
            // userCallback(data) {
            //     this.user = data[0];
            // },
            submitEvent() {
                if(!this.phone || !this.point) {
                    this.$modal({content: '请选择用户和点位'});
                    return;
                }

                let index = this.points.findIndex(item => item === this.point);
                this.$api.post('/manage/maintain', {
                    phone: this.phone,
                    point_id: this.pointIds[index]
                }).then((res) => {
                    this.$alert.success({content: '新建维护人员成功'});
                    this.show = false;
                    this.$emit('updateData');
                }).catch((error) => {
                    this.$alert.error({content: '新建维护人员失败:' + error});
                });
            }
        }
    }
</script>

<style scoped>
    .create {
        width: 400px;
    }
    .content{
        padding: 0 30px;
    }
    .content > .item {
        margin-top: 30px;
    }

    .content > .item > div:nth-of-type(2) {
        height: 36px;
        line-height: 36px;
        margin-top: 8px;
    }

    .content > .item > .ipt > input {
        padding: 0 10px;
        border: 1px solid rgba(204, 204, 204, 1);
        border-radius: 3px;
    }
     .submit {
        margin-top: 50px;
    }
</style>